import { render, staticRenderFns } from "./DataTablePageInfo.vue?vue&type=template&id=7132aed9&scoped=true&"
import script from "./DataTablePageInfo.vue?vue&type=script&lang=js&"
export * from "./DataTablePageInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePageInfo.vue?vue&type=style&index=0&id=7132aed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7132aed9",
  null
  
)

export default component.exports